import React from 'react'
import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '../../../../common/components/SectionWrapper/SectionWrapper'
import { InstallmentsView } from '../../../../common/components/InstallmentsView/InstallmentsView'
import {
  getUpliftedTcv,
  withInstallmentAmounts,
} from '../../../../common/components/InstallmentsView/InstallmentsView.utils'
import { resolveSeedUpliftPercent } from '../../../../common/utils/renewalPricingTerms'
import { SubscriptionDetailObject } from '../../../../modules/subscription/reducer'
import {
  getSubscriptionContractStartDate,
  getSubscriptionRenewalDetailsItem,
  getSubscriptionRenewalInstallments,
} from '../subscriptionDetailHelpers'

interface RenewalInstallmentsSectionProps {
  subscriptionDetail: SubscriptionDetailObject
  classes: { sectionContent?: string }
}

export const RenewalInstallmentsSection: React.FC<
  RenewalInstallmentsSectionProps
> = ({ subscriptionDetail, classes }) => {
  const rows = getSubscriptionRenewalInstallments(subscriptionDetail)
  if (!rows.length) return null

  const renewalDetails = getSubscriptionRenewalDetailsItem(subscriptionDetail)
  const tcv = getUpliftedTcv(
    Number(subscriptionDetail.subscription?.tcv) || 0,
    resolveSeedUpliftPercent(
      renewalDetails as Parameters<typeof resolveSeedUpliftPercent>[0]
    )
  )

  return (
    <SectionWrapper heading="Renewal installments" icon={faListUl}>
      <div
        className={classes.sectionContent}
        data-testid="subscription-renewal-installments"
      >
        <InstallmentsView
          installments={withInstallmentAmounts(rows, tcv)}
          currencySymbol={
            subscriptionDetail.subscription?.awsAgreementId
              ? subscriptionDetail.subscription?.currencySymbol ||
                subscriptionDetail.entitlements?.[0]?.currencySymbol ||
                '$'
              : '$'
          }
          hideTcv
          layout="renewalSchedule"
          contractStartDate={
            getSubscriptionContractStartDate(subscriptionDetail) ||
            subscriptionDetail.paymentSchedule?.[0]?.paymentDate
          }
        />
      </div>
    </SectionWrapper>
  )
}
